import { render } from "./JobMemberAvatars.vue?vue&type=template&id=474e4235&scoped=true"
import script from "./JobMemberAvatars.vue?vue&type=script&lang=js"
export * from "./JobMemberAvatars.vue?vue&type=script&lang=js"

import "./JobMemberAvatars.vue?vue&type=style&index=0&id=474e4235&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474e4235"]])

export default __exports__